import { HTMLAttributes, ReactElement } from 'react';
import { CopyIcon } from '../widgets';
import { CopyableFieldContainer } from './styles/copyable-field';

export const CopyableField: React.FC<HTMLAttributes<HTMLDivElement> & { textElement: ReactElement; text: string }> = ({
	text,
	textElement,
	...restProps
}) => {
	return (
		<CopyableFieldContainer {...restProps}>
			<div>{textElement}</div>
			<div>
				<CopyIcon text={text} />
			</div>
		</CopyableFieldContainer>
	);
};
